import React, { ComponentProps, ReactElement, useContext } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { WH, WW } from '_utils';
import { smallestFontSize, smallestMargin, subtitleFontSize } from '_utils/sizes';
import { screenMargin } from '_utils/sizes.web';
import { ThemeContext } from '_utils/themeContext';
import { CacheImage, HeimeText } from 'Components';
import { UnixTimeCode } from 'types/Utility';
import ReservationChips from './ReservationChips';

interface ReservationListItemProps {
    onPress: () => void;
    absoluteChips: ReactElement | null;
    image: ComponentProps<typeof CacheImage>['source'];
    start_at: UnixTimeCode;
    end_at: UnixTimeCode;
    title: string;
    chips: ReactElement | null;
    description: string | null;
    optionalContent: ReactElement | null;
}

const ReservationListItem = ({
    onPress,
    absoluteChips,
    image,
    start_at,
    end_at,
    title,
    chips,
    description,
    optionalContent,
}: ReservationListItemProps): ReactElement => {
    const { theme } = useContext(ThemeContext);

    return (
        <TouchableOpacity style={[style.main, { borderColor: theme.lightGreen }]} onPress={onPress}>
            <View style={style.absolute_tag_container}>{absoluteChips}</View>
            <CacheImage resizeMode={'cover'} source={image} style={style.image} />
            <Text style={style.title}>{title}</Text>
            <ReservationChips start_at={start_at} end_at={end_at}>
                {chips}
            </ReservationChips>
            {description ? (
                <HeimeText style={[style.reasonText, { color: theme.darkGray }]}>{description}</HeimeText>
            ) : null}
            {optionalContent}
        </TouchableOpacity>
    );
};

const style = StyleSheet.create({
    main: {
        paddingLeft: WW * 0.05,
        paddingRight: WW * 0.05,
        paddingTop: WW * 0.02,
        paddingBottom: WW * 0.05,
        alignItems: 'stretch',
        marginBottom: WW * 0.02,
        borderWidth: 1,
        position: 'relative',
    },
    image: {
        width: '100%',
        height: WH * 0.25,
        marginBottom: WW * 0.02,
    },
    chipStyle: {
        marginTop: WW * 0.02,
    },
    lockButton: {
        marginTop: WW * 0.02,
    },
    title: {
        fontWeight: 'bold',
        fontSize: WW * 0.06,
    },
    absolute_tag_container: {
        position: 'absolute',
        zIndex: 1,
        left: screenMargin,
        right: screenMargin,
        top: WW * 0.04,
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    tagText: {
        marginLeft: WW * 0.02,
        fontSize: subtitleFontSize,
    },
    icon: {
        marginRight: WW * 0.02,
    },
    reasonText: { fontSize: smallestFontSize, marginTop: smallestMargin },
});

export default ReservationListItem;
